/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Contents } from '../../models/contents';
import { ContentsApiRespModel } from '../../models/contents-api-resp-model';

export interface ApiMasterContentAddPost$Params {
      body?: Contents
}

export function apiMasterContentAddPost(http: HttpClient, rootUrl: string, params?: ApiMasterContentAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterContentAddPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentsApiRespModel>;
    })
  );
}

apiMasterContentAddPost.PATH = '/api/Master/Content/Add';
